module.exports = __webpack_public_path__ + "static/media/pnb-logo.3b2fa325.png";